export const BULK_MAIL_SIGNATURE_IDS = ["Jay", "Aaryan", "Aditya"] as const;
export type BulkMailSignatureId = (typeof BULK_MAIL_SIGNATURE_IDS)[number];

/** Delimiters so the client can swap the signature block without replacing the whole template. */
export const BULK_MAIL_SIGNATURE_START = "<!--GTSETU_BULK_SIG_START-->";
export const BULK_MAIL_SIGNATURE_END = "<!--GTSETU_BULK_SIG_END-->";

const SIGNATURE_HTML: Record<BulkMailSignatureId, string> = {
  Jay: `<table cellpadding="0" cellspacing="0" style="font-family: Arial, sans-serif; width: 100%;" width="100%">
	<tbody valign="middle">
		<tr valign="inherit">
			<td style="vertical-align: top; padding-right: 15px; width: 130px;" valign="top"><img src="https://gtsetu.com/wp-content/uploads/2026/03/Jay-Joshi-1-e1774684510560.png" width="110" style="border-radius: 50%;" alt=""></td>
			<td style="vertical-align: top;" valign="top">

				<p style="margin:0; font-size:16px; font-weight:bold; color:#000;">Jay Joshi</p>

				<p style="margin:2px 0; font-size:14px; color:#555;">Founder &amp; CEO</p>

				<p style="margin:2px 0;"><a href="https://gtsetu.com" style="color:#0073e6; text-decoration:none;">gtsetu.com&nbsp;</a></p>

				<p style="margin:2px 0; font-size:14px;">M: +91 91756 00107</p>

				<p style="margin:2px 0; font-size:14px;">E: <a href="mailto:jay.joshi@gtsetu.com" style="color:#0073e6; text-decoration:none;">&nbsp;jay.joshi@gtsetu.com&nbsp;</a></p>

				<p style="margin:5px 0;"><a href="https://www.linkedin.com/in/jay-s-joshi/" style="color:#0073e6; text-decoration:none;">Connect with me on LinkedIn&nbsp;</a></p>
			</td>
		</tr>
		<tr valign="inherit">
			<td colspan="2" style="padding-top:10px;" valign="inherit">

				<p style="margin:0; font-size:14px; font-weight:bold; color:#0a5fa8;">Helping Companies Collaborate Globally &mdash; Securely!</p>

				<p style="margin:2px 0; font-size:13px; color:#555;">B2B Platform for Manufacturing &amp; Business Partnerships</p>
			</td>
		</tr>
	</tbody>
</table>`,
  Aaryan: `<table cellpadding="0" cellspacing="0" style="font-family: Arial, sans-serif; width: 100%;" width="100%">
	<tbody valign="middle">
		<tr valign="inherit">
			<td style="vertical-align: top; padding-right: 15px; width: 130px;" valign="top"><img src="https://gtsetu.com/wp-content/uploads/2026/03/Aaryan-Toro-1.png" width="110" style="border-radius: 50%;" alt=""></td>
			<td style="vertical-align: top;" valign="top">

				<p style="margin:0; font-size:16px; font-weight:bold; color:#000;">Aaryan Toro</p>

				<p style="margin:2px 0; font-size:14px; color:#555;">Operations</p>

				<p style="margin:2px 0;"><a href="https://gtsetu.com" style="color:#0073e6; text-decoration:none;">gtsetu.com&nbsp;</a></p>

				<p style="margin:2px 0; font-size:14px;">M: +91 70839 60762</p>

				<p style="margin:2px 0; font-size:14px;">E: <a href="mailto:aaryan.toro@gtsetu.com" style="color:#0073e6; text-decoration:none;">aaryan.toro@gtsetu.com&nbsp;</a></p>

				<p style="margin:5px 0;"><a href="https://www.linkedin.com/in/aaryantoro/" style="color:#0073e6; text-decoration:none;">Connect with me on LinkedIn&nbsp;</a></p>
			</td>
		</tr>
		<tr valign="inherit">
			<td colspan="2" style="padding-top:10px;" valign="inherit">

				<p style="margin:0; font-size:14px; font-weight:bold; color:#0a5fa8;">Helping Companies Collaborate Globally &mdash; Securely!</p>

				<p style="margin:2px 0; font-size:13px; color:#555;">B2B Platform for Manufacturing &amp; Business Partnerships</p>
			</td>
		</tr>
	</tbody>
</table>`,
  Aditya: `<table cellpadding="0" cellspacing="0" style="font-family: Arial, sans-serif; width: 100%;" width="100%">
	<tbody valign="middle">
		<tr valign="inherit">
			<td style="vertical-align: top; padding-right: 15px; width: 130px;" valign="top"><img src="https://gtsetu.com/wp-content/uploads/2026/04/1773220226201.jpg" width="110" style="border-radius: 50%;" alt=""></td>
			<td style="vertical-align: top;" valign="top">

				<p style="margin:0; font-size:16px; font-weight:bold; color:#000;">Aditya Belekar</p>

				<p style="margin:2px 0; font-size:14px; color:#555;">Chief Marketing Officer</p>

				<p style="margin:2px 0;"><a href="https://gtsetu.com" style="color:#0073e6; text-decoration:none;">gtsetu.com</a></p>

				<p style="margin:2px 0; font-size:14px;">M: +91-9579639731</p>

				<p style="margin:2px 0; font-size:14px;">E: <a href="mailto:aditya.belekar@gtsetu.com" style="color:#0073e6; text-decoration:none;">&nbsp;aditya.belekar@gtsetu.com&nbsp;</a></p>

				<p style="margin:5px 0;"><a href="https://www.linkedin.com/in/adityakumarb/" style="color:#0073e6; text-decoration:none;">Connect with me on LinkedIn</a></p>
			</td>
		</tr>
		<tr valign="inherit">
			<td colspan="2" style="padding-top:10px;" valign="inherit">

				<p style="margin:0; font-size:14px; font-weight:bold; color:#0a5fa8;">Helping Companies Collaborate Globally &mdash; Securely!</p>

				<p style="margin:2px 0; font-size:13px; color:#555;">B2B Platform for Manufacturing &amp; Business Partnerships</p>
			</td>
		</tr>
	</tbody>
</table>`,
};

export function getBulkMailSignatureHtml(id: BulkMailSignatureId): string {
  return SIGNATURE_HTML[id];
}

export function replaceBulkMailSignature(html: string, id: BulkMailSignatureId): string {
  const i = html.indexOf(BULK_MAIL_SIGNATURE_START);
  const j = html.indexOf(BULK_MAIL_SIGNATURE_END);
  if (i === -1 || j === -1 || j < i) {
    return html;
  }
  return html.slice(0, i + BULK_MAIL_SIGNATURE_START.length) + getBulkMailSignatureHtml(id) + html.slice(j);
}

export function isBulkMailSignatureId(value: string): value is BulkMailSignatureId {
  return (BULK_MAIL_SIGNATURE_IDS as readonly string[]).includes(value);
}
